import React from 'react';
import styles from './AdDetailsWebLoader.scss';


const AdDetailsWebLoader = () => (
  <div className={styles.content}>
    <div className={`${styles.topBar} ${styles.skeletonLoader}`}></div>

    <div className={styles.detailsWrapper}>

      <div className={styles.summaryWrapper}>
        <div className={styles.heading}>
          <div>
            <div className={`${styles.skeletonLoader} ${styles.title}`}></div>
            <div className={`${styles.skeletonLoader} ${styles.adInfo}`}></div>
          </div>
          <div>
            <div className={`${styles.skeletonLoader} ${styles.priceEur}`}></div>
          </div>
        </div>

        <div className={`${styles.skeletonLoader} ${styles.imageWrapper}`}></div>
      </div>

      <div className={styles.wrapSellerSection}>
        <div className={`${styles.skeletonLoader} ${styles.adDetails}`}> </div> 
        <div className={`${styles.skeletonLoader} ${styles.location}`}></div>
      </div>

    </div>
  </div>
 
);

export default AdDetailsWebLoader;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/AdDetailsWebLoader/index.tsx